/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelTipoPraticaRegolaPunteggioPredicatoDTO } from '../model/models';
import { TipoPraticaRegolaPunteggioPredicatoCreationForm } from '../model/models';
import { TipoPraticaRegolaPunteggioPredicatoDTO } from '../model/models';
import { TipoPraticaRegolaPunteggioPredicatoListFilter } from '../model/models';
import { TipoPraticaRegolaPunteggioPredicatoPatchForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateTipoPraticaRegolaPunteggioPredicatoRequestParams {
    idTipoPratica: string;
    idCategoria: string;
    idRegola: string;
    tipoPraticaRegolaPunteggioPredicatoCreationForm: TipoPraticaRegolaPunteggioPredicatoCreationForm;
}

export interface DeleteTipoPraticaRegolaPunteggioPredicatoRequestParams {
    idTipoPratica: string;
    idCategoria: string;
    idRegola: string;
    idPredicato: string;
}

export interface GetTipoPraticaRegolaPunteggioPredicatoRequestParams {
    idTipoPratica: string;
    idCategoria: string;
    idRegola: string;
    idPredicato: string;
}

export interface ListTipoPraticaRegolaPunteggioPredicatiRequestParams {
    idTipoPratica: string;
    idCategoria: string;
    idRegola: string;
    filter: TipoPraticaRegolaPunteggioPredicatoListFilter;
    pageable: Pageable;
}

export interface UpdateTipoPraticaRegolaPunteggioPredicatoRequestParams {
    idTipoPratica: string;
    idCategoria: string;
    idRegola: string;
    idPredicato: string;
    tipoPraticaRegolaPunteggioPredicatoPatchForm: TipoPraticaRegolaPunteggioPredicatoPatchForm;
}


export interface TipoPraticaRegolaPunteggioPredicatoControllerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Crea un nuovo predicato della regola
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}/predicati
* @param requestParameters
     */
    createTipoPraticaRegolaPunteggioPredicato(requestParameters: CreateTipoPraticaRegolaPunteggioPredicatoRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaRegolaPunteggioPredicatoDTO>;

    /**
     * Elimina un predicato della regola
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}/predicati/{idPredicato}
* @param requestParameters
     */
    deleteTipoPraticaRegolaPunteggioPredicato(requestParameters: DeleteTipoPraticaRegolaPunteggioPredicatoRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Dettaglio di un predicato della regola
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}/predicati/{idPredicato}
* @param requestParameters
     */
    getTipoPraticaRegolaPunteggioPredicato(requestParameters: GetTipoPraticaRegolaPunteggioPredicatoRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaRegolaPunteggioPredicatoDTO>;

    /**
     * Lista paginata dei predicati della regola (filtri: fonte, operatore)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}/predicati
* @param requestParameters
     */
    listTipoPraticaRegolaPunteggioPredicati(requestParameters: ListTipoPraticaRegolaPunteggioPredicatiRequestParams, extraHttpRequestParams?: any): Observable<PagedModelTipoPraticaRegolaPunteggioPredicatoDTO>;

    /**
     * Replace di un predicato della regola (richiede version)
     * 
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}/predicati/{idPredicato}
* @param requestParameters
     */
    updateTipoPraticaRegolaPunteggioPredicato(requestParameters: UpdateTipoPraticaRegolaPunteggioPredicatoRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaRegolaPunteggioPredicatoDTO>;

}
